<div class="contacts-container">
  <div class="contacts-content" [ngClass]="getContentClasses()">

    @if (showEmptyField) {
      <div class="empty-field-space"></div>
    }

    <h1 class="main-title field" [ngClass]="getTitleClasses()"
    [class.has-difference]=" (hasDifferences('FirstName') || hasDifferences('LastName'))">{{ contactToDisplay?.FirstName }} {{ contactToDisplay?.LastName }}</h1>
    @if (this.selected === this.count) {
      <div>
        <h3 class="light-title field"
        [class.has-difference]=" hasDifferences('ContactTypeText')">{{ contactToDisplay?.ContactTypeText }}</h3>
        <div class="action-desktop">
          <h3 class="info-title" fiTranslation="REQUEST_DETAIL_HEADLINE_CONTACT"></h3>
          <div class="field">
            <div class="field-inner mail-inner" [class.has-difference]=" hasSameNames(contactToDisplay?.Email)">
              @if (contactToDisplay?.Email && !contactToDisplay?.Email?.endsWith('@temp.finstral.com')) {
                <span
                  class="info-line mail " #mail [isTitle]="true" fiTranslation="ALT_TEXT_CONTACT_DETAIL_EMAIL"
                  matTooltip="{{mail.dataset.matTooltip}}" matTooltipPosition="below" matTooltipClass='tooltip-style'>
                  <a class="custom-link mail"
                    [class.prefer]="contactToDisplay?.ContactMethodName === 'E-MAIL'"
                  href="mailto: {{ contactToDisplay?.Email }}">{{ contactToDisplay?.Email }}</a>
                  @if (contactToDisplay?.ContactMethodName === 'E-MAIL') {
                    <span class="prefer-contact"
                    fiTranslation="REQUEST_DETAIL_HEADLINE_PREFERENCE"></span>
                  }
                </span>
              } @else {
                @if (contactToDisplay?.Email) {
                  <span class="info-line mail default-email">
                    <span fiTranslation="CONTACT_ERRORMSG_HEADLINE_NO_EMAIL"></span>
                  </span>
                }
              }
            </div>
          </div>
          <div class="field">
            <span class="field-inner mail-inner"
              [class.has-difference]="hasSameNames(contactToDisplay?.AdditionalEmail) && contactToDisplay?.AdditionalEmail">
              @if (contactToDisplay?.AdditionalEmail && !contactToDisplay?.AdditionalEmail?.endsWith('@temp.finstral.com')) {
                <span
                  class="info-line mail">
                  <a class="custom-link"
                  href="mailto: {{ contactToDisplay?.AdditionalEmail }}">{{ contactToDisplay?.AdditionalEmail }}</a>
                </span>
              }
            </span>
          </div>
          <div class="field">
            @if (contactPhone) {
              <span class="field-inner" [class.has-difference]="hasDifferences('Phone')">
                @if (contactPhone) {
                  <span class="info-line telephone" #telephone [isTitle]="true"
                    fiTranslation="ALT_TEXT_CONTACT_DETAIL_PHONE" matTooltip="{{telephone.dataset.matTooltip}}"
                    matTooltipPosition="below" matTooltipClass='tooltip-style'>
                    <a class="custom-link" href="tel: {{ contactPhone }}">{{ contactPhone }}</a>
                    @if (contactToDisplay?.ContactMethodName === 'TELEFON') {
                      <span class="prefer-contact"
                      fiTranslation="REQUEST_DETAIL_HEADLINE_PREFERENCE"></span>
                    }
                  </span>
                }
              </span>
            }
          </div>
          <div class="field">
            @if (contactMobile) {
              <span class="field-inner" [class.has-difference]="hasDifferences('Mobile')"
                >
                @if (contactMobile) {
                  <span class="info-line phone" #mobile [isTitle]="true"
                    fiTranslation="ALT_TEXT_CONTACT_DETAIL_MOBIL" matTooltip="{{mobile.dataset.matTooltip}}"
                    matTooltipPosition="below" matTooltipClass='tooltip-style'>
                    <a class="custom-link" href="tel: {{ contactMobile }}">{{ contactMobile }}</a>
                    @if (contactToDisplay?.ContactMethodName === 'MOBILE') {
                      <span class="prefer-contact"
                      fiTranslation="REQUEST_DETAIL_HEADLINE_PREFERENCE"></span>
                    }
                  </span>
                }
              </span>
            }
          </div>
          <div class="space" [ngClass]="getHeight(contactEmptyCount)"></div>
          @if (contactToDisplay?.LanguageText) {
            <h3 class="info-title" fiTranslation="FORM_HEADLINE_LANGUAGE"></h3>
          }
          @if (contactToDisplay?.LanguageText) {
            <span class="info-line" [class.has-difference]="hasDifferences('LanguageText')"
            >{{ contactToDisplay?.LanguageText }}</span>
          }
          <h3 class="info-title" fiTranslation="REQUEST_DETAIL_HEADLINE_ADDRESS"></h3>
          <div class="field">
            @if (contactToDisplay?.Company) {
              <span class="info-line"
              [class.has-difference]="hasDifferences('Company')">{{ contactToDisplay?.Company }}</span>
            }
          </div>
          <div class="field">
            @if (contactToDisplay?.Address) {
              <span class="info-line"
              [class.has-difference]="hasDifferences('Address')">{{ contactToDisplay?.Address }}</span>
            }
          </div>
          <div class="field">
            @if (contactToDisplay?.AddressExt) {
              <span class="info-line"
              [class.has-difference]="hasDifferences('AddressExt')">{{ contactToDisplay?.AddressExt }}</span>
            }
          </div>
          <div class="field">
            @if (contactToDisplay?.ZipCode || contactToDisplay?.City) {
              <span class="info-line"
                [class.has-difference]="(hasDifferences('ZipCode') || hasDifferences('City'))">
                <span [class.default-color]="!hasDifferences('ZipCode')">{{ contactToDisplay?.ZipCode }} </span>
                <span [class.default-color]="!hasDifferences('City')">{{ contactToDisplay?.City }}</span>
              </span>
            }
          </div>
          <div class="field">
            @if (contactToDisplay?.CountryText) {
              <span class="info-line"
              [class.has-difference]="hasDifferences('CountryText')">{{ contactToDisplay?.CountryText }}</span>
            }
          </div>
          <div class="field">
            @if (contactToDisplay?.VatNumber) {
              <span class="info-line"
              [class.has-difference]="hasDifferences('VatNumber')">{{ contactToDisplay?.VatNumber }}</span>
            }
          </div>
          <div class="field">
            @if (contactToDisplay?.Website) {
              <span class="info-line"
              [class.has-difference]="hasDifferences('Website')">{{ contactToDisplay?.Website }}</span>
            }
          </div>
          <!--        <span-->
          <!--          *ngIf="!(this.contactToDisplay?.Address) && !(this.contactToDisplay?.ZipCode) && !(this.contactToDisplay?.CountryText) && !(this.contactToDisplay?.City)"-->
        <!--          class="info-line"> - </span>-->
        <div class="space" [ngClass]="getHeight(addressEmptyCount)"></div>
        <h3 class="info-title" fiTranslation="REQUEST_DETAIL_HEADLINE_CONSENT_PRIVACY"></h3>
        <span #warning [isTitle]="true" fiTranslation="ALT_TEXT_REQUEST_LIST_INFORMATION"
          matTooltip="{{warning.dataset.matTooltip}}" matTooltipPosition="below" matTooltipClass='tooltip-style'>
          <span class="info-line warning"
          fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_PRIVACY_AGREE_TO_STORE_DATA_1"></span>
        </span>
        <div class="creator-box" [class.empty-creator]="!existingContact">
          @if (!!leadData?.creator && existingContact) {
            <div>
              <h3 class="info-title" fiTranslation="REQUEST_DETAIL_HEADLINE_CREATE"></h3>
              @if (leadData) {
                <div class="info-box">
                  @if (!!leadData.creator.AvatarURL) {
                    <img [src]="leadData.creator.AvatarURL" alt="Contact image">
                  }
                  @if (!leadData.creator.AvatarURL) {
                    <div class="letters">
                      <b>{{ getNameLiterals(leadData.creator.FirstName + ' ' + leadData.creator.LastName) }}</b>
                    </div>
                  }
                  <div>
                    <span class="info-line creator">{{ leadData.creator.FirstName + ' ' + leadData.creator.LastName}}</span>
                    <span class="info-line date">{{dateTimeHelper.getFormattedDate(leadData?.creTS)}}
                      @if (getLanguage() !== 'it') {
                        <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME"></span>
                      }
                    </span>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>

</div>

